import React from 'react';
import { Box, Paper, Tooltip } from '@mui/material';

// macOS-style color palette (10x10 grid)
const COLORS = [
    // Row 1: Grayscale & Basics
    '#000000', '#1a1a1a', '#333333', '#4d4d4d', '#666666', '#808080', '#999999', '#b3b3b3', '#cccccc', '#ffffff',
    // Row 2: Reds & Pinks
    '#ff0000', '#ff4d4d', '#ff9999', '#ffcccc', '#cc0000', '#990000', '#ff0066', '#ff6699', '#ffb3cc', '#cc0052',
    // Row 3: Oranges & Corals
    '#ff6600', '#ff8533', '#ffad66', '#ffd1b3', '#cc5200', '#993d00', '#ff9933', '#ffb366', '#ffd9b3', '#cc7a29',
    // Row 4: Yellows & Golds
    '#ffcc00', '#ffd633', '#ffe066', '#fff0b3', '#cca300', '#997a00', '#ffff00', '#ffff66', '#ffffb3', '#cccc00',
    // Row 5: Greens (Lime/Bright)
    '#99cc00', '#b3d933', '#ccbf66', '#e6f2b3', '#7aa300', '#5c7a00', '#66ff33', '#8cff66', '#b3ff99', '#52cc29',
    // Row 6: Greens (Forest/Teal)
    '#00cc00', '#33d933', '#66e666', '#b3f2b3', '#00a300', '#007a00', '#00cc66', '#33d98c', '#66e6b3', '#00a352',
    // Row 7: Cyans & Blues
    '#00cccc', '#33d9d9', '#66e6e6', '#b3f2f2', '#00a3a3', '#007a7a', '#0066cc', '#3385d9', '#66a3e6', '#b3d1f2',
    // Row 8: Blues & Indigos
    '#0000ff', '#3333ff', '#6666ff', '#b3b3ff', '#0000cc', '#000099', '#3333cc', '#5c5cd9', '#8585e6', '#adadf2',
    // Row 9: Purples & Violets
    '#6600cc', '#8533d9', '#a366e6', '#d1b3f2', '#5200a3', '#3d007a', '#9900cc', '#ad33d9', '#c266e6', '#d6b3f2',
    // Row 10: Browns & Earth Tones
    '#663300', '#854d1a', '#a36633', '#d1b399', '#522900', '#3d1f00', '#996633', '#b3804d', '#cc9966', '#e6b380',
];

const ColorPicker = ({ color, onChange }) => {
    return (
        <Paper
            elevation={3}
            sx={{
                p: 1.5,
                width: 'fit-content',
                borderRadius: '12px', // macOS style rounded corners
                backgroundColor: '#f5f5f7', // macOS light gray background
                border: '1px solid #e0e0e0',
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(10, 1fr)',
                    gap: '6px',
                    width: '100%',
                    maxWidth: '320px',
                }}
            >
                {COLORS.map((c) => (
                    <Tooltip title={c} key={c} arrow placement="top">
                        <Box
                            onClick={() => onChange(c)}
                            sx={{
                                width: '24px',
                                height: '24px',
                                backgroundColor: c,
                                borderRadius: '6px',
                                cursor: 'pointer',
                                border: color === c ? '2px solid #007aff' : '1px solid rgba(0,0,0,0.1)',
                                boxShadow: color === c ? '0 0 0 2px #fff inset' : 'none',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.2)',
                                    zIndex: 2,
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    border: '2px solid #000', // Thick black border on hover
                                },
                                '@media (max-width: 600px)': {
                                    width: '20px',
                                    height: '20px',
                                },
                            }}
                        />
                    </Tooltip>
                ))}
            </Box>
        </Paper>
    );
};

export default ColorPicker;
